module.exports = __webpack_public_path__ + "img/2.43124602.jpg";